<template>
	<div id="importOrderDialog">
		<el-dialog  :title="isAdd?'新增库位':'编辑库位'"  :visible.sync="isShowDialog" :width="W?'30%':'40%'" center :close-on-click-modal="false" @close="cancelAddDialog">
            <el-form :model="addForm" :rules="rules" ref="addForm" style="width:100%;" class="add_form">
                <el-row>
                    <el-col :span="16" :offset="4">
                        <div  class="">
                        <span class="title">库位名称：</span>
                            <el-form-item  class="value" >
                                <span>{{parsePositionName?parsePositionName:'  '}}</span>
                            </el-form-item>
                        </div>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="16" :offset="4">
                        <div  class="">
                            <span class="title">区编码：</span>
                            <el-form-item class="value" prop="areaCode"  :rules="rules.areaCode">
                                <el-input v-model.trim="addForm.areaCode" maxlength="16"></el-input>
                            </el-form-item>
                        </div>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="16" :offset="4">
                        <div  class="">
                            <span class="title">货列号：</span>
                            <el-form-item class="value" prop="cargoColumnNumber"  :rules="rules.cargoColumnNumber">
                                <el-input v-model.trim="addForm.cargoColumnNumber" maxlength="16"></el-input>
                            </el-form-item>
                        </div>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="16" :offset="4">
                        <div  class="">
                            <span class="title">列：</span>
                            <el-form-item class="value" prop="positionColumn"  :rules="rules.positionColumn">
                                <el-input v-model.trim="addForm.positionColumn" maxlength="16"></el-input>
                            </el-form-item>
                        </div>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="16" :offset="4">
                        <div  class="">
                            <span class="title">层：</span>
                            <el-form-item class="value" prop="positionLayer"  :rules="rules.positionLayer">
                                <el-input v-model.trim="addForm.positionLayer" maxlength="16"></el-input>
                            </el-form-item>
                        </div>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="16" :offset="4">
                        <div  class="">
                            <span class="title">状态：</span>
                            <el-form-item class="value" prop="positionStatus"  :rules="rules.positionStatus">
                                <el-select  v-model="addForm.positionStatus" placeholder="使用状态" >
                                <el-option  key="0" :value="0" label="启用"></el-option>
                                <el-option  key="1" :value="1" label="停用"></el-option>
                            </el-select>
                            </el-form-item>
                        </div>
                    </el-col>
                </el-row>
            </el-form>

			<div style="text-align: center;">
                <el-button type="primary" @click="submitAddStock">确 定</el-button>
                <el-button  @click="cancelAddDialog">取 消</el-button>
            </div>

		</el-dialog>
	</div>
</template>

<script>
export default {
	name: 'AddStockDialog',
	props: {
        showBatchStock: Boolean,
        factoryModelId:Number,
        isAdd: Boolean,
        editInfo:{
            type:Object,

        }
	},
	data() {
        let that = this
		return {
            
            W:true,
            isShowDialog: false,
            addForm:{},
            rules:{
                areaCode: [{required: true, message: '请输入库区编码', trigger: 'blur'}],
                cargoColumnNumber: [{required: true, message: '请输入货列号', trigger: 'blur'}],
                positionColumn: [{required: true, message: '请输入列', trigger: 'blur'}],
                positionLayer: [{required: true, message: '请输入存', trigger: 'blur'}],
                positionStatus: [{required: true, message: '请选择是否开启', trigger: 'blur'}],
            }
        }
    },
    mounted(){
        let w = document.documentElement.clientWidth || document.body.clientWidth;
        this.W = w>=1900?true:false
        window.onresize = () => {
            let w = document.documentElement.clientWidth || document.body.clientWidth;
            this.W = w>=1900?true:false
        }
    },
    computed:{
        parsePositionName(){
            let row = this.addForm
            let cargoColumnNumber = row.cargoColumnNumber?`-${row.cargoColumnNumber}`:''
            let areaCode = row.areaCode?`${row.areaCode}`:''
            let layer = row.positionLayer?`-${row.positionLayer}`:''
            let column = row.positionColumn?`-${row.positionColumn}`:''
            row.positionName = `${areaCode}${cargoColumnNumber}${column}${layer}` 
            return row.positionName 
        }
    },
    methods:{
        submitAddStock(){
            this.$refs['addForm'].validate((valid) => {
                if(valid){
                    this.addForm.parentFactoryModelId = this.factoryModelId
                    
                    let url = '/api/factoryModelPosition/updateFactoryModelPosition'
                    let msg = '修改成功'
                    if(this.isAdd){
                        msg = '新增成功'
                        url = '/api/factoryModelPosition/addFactoryModelPosition'
                    }
                    this.$RequestUtil.post({
                        url,
                        type:'sync',
                        params:this.addForm,
                        success: async (res) => {
                            if(res.code ==0){
                                
                                this.$message.success(msg)
                                
                                await this.$parent.loadOrganizationData(this.factoryModelId) 
                                this.cancelAddDialog()
                            }else{
                                this.$message.error(res.msg || res.message);
                            }
                        }
                    })
                }
            })
        },
        cancelAddDialog(){
            this.$refs['addForm'].clearValidate()
            this.$parent.showSingleStock = false
        }
        
    },
    watch: {
		"showBatchStock": function (newVal, oldVal) {
            if(newVal){
                if(!this.isAdd){
                    this.addForm = this.editInfo
                }
            }
			this.isShowDialog = this.showBatchStock;
		},
	},
}
</script>
<style scoped>
.title{
    display: inline-block;
    width: 70px;
    text-align: right;
}
.value{
    display: inline-block;
}
</style>



// WEBPACK FOOTER //
// src/views/FactoryModel/singleAddStock.vue